import { gql } from '@apollo/client';

export const GET_CATEGORY_BY_ID = gql`
  query GetCategoryById($id: ID!) {
    getCategoryById(id: $id) {
      id
      name
      slug
    }
  }
`;
export const GET_VENDOR_BY_ID = gql`
  query GetVendorById($vendorId: ID!) {
    getVendorById(vendorId: $vendorId) {
      id
      businessName
      email
      phone
      address
    }
  }
`;
export const GET_SHOP_BY_ID = gql`
  query GetShopById($shopId: ID!) {
    getShopById(shopId: $shopId) {
      id
      shopName
      location
    }
  }
`;
